const DENIED_PATH_PATTERNS = [
  /^\/games\/[^/]+\/sign-in(\/|$)/,
  /^\/games\/[^/]+\/signup(\/|$)/,
  /^\/games\/[^/]+\/register(\/|$)/,
  /^\/games\/[^/]+\/versus(\/|$)/,
  /^\/games\/[^/]+\/tournament\/[^/]+\/result\/[^/]+(\/|$)/,
  /^\/games\/[^/]+\/live-event(\/|$)/,
  /^\/games\/[^/]+\/brackets-v2(\/|$)/,
  /^\/games\/[^/]+\/bracket-versus(\/|$)/,
  /^\/games\/[^/]+\/brackets-results(\/|$)/,
  /^\/games\/[^/]+\/create(\/|$)/,
  /^\/games\/[^/]+\/tutorial(\/|$)/,
  /^\/games\/[^/]+\/deposit(\/|$)/,
];

export function shouldShowWebArcadeHeader(pathname: string): boolean {
  if (!pathname) return false;
  return !DENIED_PATH_PATTERNS.some((pattern) => pattern.test(pathname));
}
